import script from "./Trace.vue?vue&type=script&setup=true&lang=js"
export * from "./Trace.vue?vue&type=script&setup=true&lang=js"

import "./Trace.vue?vue&type=style&index=0&id=1bf4cf46&lang=less&scoped=true"
import "./Trace.vue?vue&type=style&index=1&id=1bf4cf46&lang=less"

import exportComponent from "E:\\Workspaces\\成品油\\成品油_基础版\\成品油溯源码（扫码）\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bf4cf46"]])

export default __exports__